import {useEffect, useRef, useContext} from 'react'
import {asEnumerable} from 'linq-es2015'
import {getItem} from '_services/agent'
import {MapContext} from '_context/MapContext'
import {ollehModule} from '../../common/mapAPIExport'
import axios from 'axios'

const LabelDetect = (props) => {
    const {ktMapIns} = useContext(MapContext);
    const labelBoxEnum = useRef([]);
    const detectPoiId = useRef(null);
    useEffect(() => {
        if(ktMapIns){
            ktMapIns.onEvent('idle', function(event) {
                getLabelBox()         
            });
            ktMapIns.onEvent('mousemove', function (event, payload) {
                ktMapIns.elem.children.layer_container.style.cursor = 'default'
                detectPoiId.current = null
                let x = event.getCoord().x
                let y = event.getCoord().y
                let result = asEnumerable(labelBoxEnum.current).FirstOrDefault(boxInfo => {
                    //console.log(`${x} , ${y} == ${boxInfo.bbox[0]}:${boxInfo.bbox[2]} , ${boxInfo.bbox[1]}:${boxInfo.bbox[3]}`)
                    if(x>boxInfo.bbox[0] && x<boxInfo.bbox[2] && y>boxInfo.bbox[1] && y<boxInfo.bbox[3]){
                        return true
                    }else{
                        return false
                    }
                })
                if(result){
                    ktMapIns.elem.children.layer_container.style.cursor = 'pointer'
                    detectPoiId.current = result.id
                }
            });
            ktMapIns.onEvent('click', function (event, payload) {
                if(detectPoiId.current){
                    getRetrievePOI(detectPoiId.current)
                }
            })
        }
    }, [ktMapIns]);

    const getLabelBox =  (id) => {
        labelBoxEnum.current = []
        if(ktMapIns.getZoom()<5){
            return
        }
        let tileIter = ktMapIns._mapTypeRegistry.ROADMAP._tiles.map(item=>{
                let tok = item._url.split('/')
                let z = tok[tok.length-3]
                let y = tok[tok.length-2]
                let x = tok[tok.length-1].split('.')[0]
                y = to16Int(Math.floor(y / 4))
                x = to16Int(Math.floor(x / 4))
                z = z.length===1 ? "0"+z : z
                return {'url':'l'+z+'/r'+y+'/c'+x+'.json'}
        }).reduce((unique, item)=>{
            return unique.filter((it)=>it.url===item.url).length===0 ? [...unique, item] : unique;
        },[]).map(item=>{
            return axios.get(`https://tile.gis.kt.com/image/labelDetect_20200721/Layers/_alllayers/${item.url}`)
        })

        Promise.all(tileIter).then((values) => {
            values.map((value) => {
                value.data.features.map((fea) => {
                    if(fea.id){
                        let box = null
                        if(fea.geometry.type==='Polygon'){
                            box = fea.geometry.coordinates[0]
                        }else if(fea.geometry.type==='MultiPolygon'){
                            box = fea.geometry.coordinates[0][0]
                        }
                        if(box){
                            labelBoxEnum.current.push({'id':fea.id, 'bbox':[box[0][0], box[0][1], box[2][0], box[2][1]]})
                        }
                    }
                })
            })
        }).catch(err => console.log(err))
    }

    const getRetrievePOI = async (id) => {
        let param = '/' + id +'?mode=NAVIGATION'
        let res = await getItem('poi',param, null, 'GET')
        if(res && res.data.pois && res.data.pois.length>0){
            let latLngPoint = new ollehModule.maps.LatLng(res.data.pois[0].point.lat, res.data.pois[0].point.lng);
            let point = ollehModule.maps.UTMK.valueOf(latLngPoint);
            let marker = new ollehModule.maps.overlay.CustomLabelMarker({
                position: point,
                map:ktMapIns,
                label:'',
            });
            marker.gapX = 10
            marker.gapY = 170
            marker['attribute'] = res.data.pois[0]
            props.infoWindow(marker, true)
        }
    }

    const to16Int = (val) => {
        return '00000000'.substring(0, 8-parseInt(val).toString(16).length) + parseInt(val).toString(16)
    }

    return ('')
}

export default LabelDetect;